// @flow

export type PianoMode = 'optin' | 'exempt';

export function setPianoMode(mode: PianoMode) {
  if (window.pianoAnalytics?.privacy) {
    window.pianoAnalytics.privacy.setMode(mode);
  } else {
    // eslint-disable-next-line no-underscore-dangle
    window.__pianoPendingMode = mode;
  }
}
